import { render, staticRenderFns } from "./VersionHistoryDrawer.vue?vue&type=template&id=f200c7c2&scoped=true&"
import script from "./VersionHistoryDrawer.vue?vue&type=script&lang=js&"
export * from "./VersionHistoryDrawer.vue?vue&type=script&lang=js&"
import style0 from "./VersionHistoryDrawer.vue?vue&type=style&index=0&id=f200c7c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f200c7c2",
  null
  
)

export default component.exports